export const LONG_PULLING_INTERVAL_TIME = 7500;

export const CONSTANTS = {
  supportEmail: 'support@parqco.com',
};
